angular.module('Itao.IndicatorMap').directive('overviewQualificationChart', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var compose = d3.hyperion.compose;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var overviewQualificationChart = function () {
    var
      svgHeight = 350,
      svgWidth = 600,
      colors = ['#366666', '#95ac00', '#7db0ca', '#c5bd76'],
      duration = 400,
      margin = {top: 30, right: 5, bottom: 0, left: 20},
      numberFormat = germanNumberFormat(',.1f');

    var chart = function (selection) {
      selection.each(function (data) {

        //calculate min and max values and check that 0 is included
        var minValue = 0;
        var maxValue = d3.max(data);
        if(!maxValue) maxValue = 100;
        var axisFormatString = ',.0f';

        var container = d3.select(this).datum([data]).classed('overview-qualification-chart', true);

        svgWidth = svgWidth ? svgWidth : selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        var colorFromBar = function (d, i) {
          return colors[i];
        };

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for each bar per district
        var x = d3.scale.ordinal()
          .domain([0, 1, 2, 3]) // use only active indicators
          .rangeRoundBands([0, width], 0.3);

        // scale for bar values
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxValue])
          .nice();

        var tickCount = Math.min(svgHeight / 40, 10);

        var bars = g.selectAll('rect')
          .data(data);

        // draw new bars
        bars
          .enter()
          .append('rect')
          .attr('class', 'value-bar')
          .style('fill', colorFromBar)
          .attr('width', 0)
          .attr('x', compose(x, sortedAccessor))
          .attr('y', y(0))
          .attr('height', 0);

        // update all bars
        bars
          .style('fill', colorFromBar)
          .attr('width', x.rangeBand())
          .attr('x', compose(x, sortedAccessor))
          .attr('y', function (d) {
            return !!d ? y(d) : y(0);
          })
          .attr('height', function (d) {
            return !!d ? Math.abs(y(0) - y(d)) : 0;
          });

        // remove unused bars
        bars.exit()
          .remove();

        var barLabels = g.selectAll('.barLabel')
          .data(data);

        barLabels.enter()
          .append('text')
          .attr('class', 'barLabel')
          .attr('text-anchor', 'middle');

        barLabels
          .attr('x', function (d, i) {
            return x(i) + (x.rangeBand() / 2);
          })
          .attr('y', function (d) {
            return !!d ? y(d) - 15 : y(0)-10;
          })
          .text(function (d) {
            return !!d ? numberFormat(d) : '—';
          });

        barLabels.exit()
          .remove();
      });
    };


    /**
     * getter/setter for svgWidth
     * @param {Function} [newSvgWidth] new svgWidth function
     * @returns {*}
     */
    chart.svgWidth = function (newSvgWidth) {
      if (!arguments.length) {
        return svgWidth;
      } else {
        svgWidth = newSvgWidth;
        return chart;
      }
    };

    return chart;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'overviewQualificationChart.html',
    scope: {
      selectedDataLayer: '=',
      selectedDistrict: '=',
      indicatorUids: '=',
      svgWidth: '@'
    },
    link: function (scope, element) {

      var overviewQualificationChartFunction = overviewQualificationChart();

      /**
       * update the chart from one of the watchers
       */
      var rerender = function () {

        if (scope.selectedDataLayer != null && scope.selectedDistrict != null && angular.isArray(scope.indicatorUids) && scope.selectedDataLayer.hasOwnProperty(scope.selectedDistrict.uid)) {

          overviewQualificationChartFunction.svgWidth(scope.svgWidth);
          var values = scope.indicatorUids.map(function (uid) {
            return scope.selectedDataLayer[scope.selectedDistrict.uid][uid];
          });

          d3.select(element.find('.widget-inner:first')[0])
            .data([values])
            .call(overviewQualificationChartFunction);
        }
      };

      var selectedDataLayerWatcher = scope.$watch('selectedDataLayer', rerender);
      var selectedDistrictWatcher = scope.$watch('selectedDistrict', rerender);
      var indicatorUidsIndicators = scope.$watchCollection('indicatorUids', rerender);

      // remove watcher on destroy
      element.on('$destroy', function () {
        selectedDataLayerWatcher();
        selectedDistrictWatcher();
        indicatorUidsIndicators();
      });
    }
  };
});
